import { Button, BackButton, Text, FormInput } from '@/components';
import { EMAIL_FORM_VALIDATIONS } from '@/utils/constants';
import { FC } from 'react';
import { useForm } from 'react-hook-form';

interface Props {
  onBackClick: () => void;
  onResetPasswordClick: (email: string) => void;
}

const ResetPasswordForm: FC<Props> = ({
  onBackClick,
  onResetPasswordClick,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty, isValid },
  } = useForm<{ email: string }>();

  const handleOnSubmit = handleSubmit(({ email }) => {
    onResetPasswordClick(email);
  });

  const disabled = !(isDirty && isValid);

  return (
    <div className="flex flex-col gap-20 w-full">
      <div className="flex flex-col gap-md">
        <BackButton onBackClick={onBackClick} />
      </div>
      <form onSubmit={handleOnSubmit} className="flex flex-col gap-md">
        <div className="flex flex-col gap-10">
          <Text value="Reset password" size="h1" />
          <Text
            className="w-11/12"
            value="Enter the email address you used to sign up, and we'll send instructions to reset your password."
            color="secondary"
          />
          <FormInput
            name="email"
            label="Email"
            type="email"
            register={register}
            rules={{
              required: 'Enter email to continue',
              validate: EMAIL_FORM_VALIDATIONS,
            }}
            errors={errors}
          />
          <Button type="submit" fullWidth disabled={disabled}>
            Reset password
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ResetPasswordForm;
